import React, { memo } from "react";

import { ArticleListContainer } from "@/marketing/ArticleList.style.jsx";

export default memo(function ArticleList({
  articles,
  count = 3,
  className,
  Icon,
}: {
  articles: Array<{
    id: string;
    coverImageUrl: string;
    title: string;
    excerpt: string;
    createdAt: number;
    link: string;
    redirect?: string;
  }>;
  count?: number;
  className?: string;
  Icon?: React.ComponentType;
}) {
  return (
    <ArticleListContainer className={className}>
      {articles.length
        ? articles.map((article, i) => {
            return (
              <a
                href={article.redirect ?? article.link}
                key={article.id}
                className="article-link"
                data-no-preload
                style={{ "--i": i }}
              >
                <article className="article-list-item">
                  {Icon && <Icon />}
                  <img
                    src={`${article.coverImageUrl}?w=380`}
                    width="336"
                    height="188"
                    alt={`${article.title} blog article`}
                    className="article-image"
                  />
                  <div className="article-meta">
                    <h4 className="article-title">{article.title as string}</h4>
                    <p className="article-excerpt">
                      {article.excerpt as string}
                    </p>
                  </div>
                </article>
              </a>
            );
          })
        : new Array(count).fill(undefined).map((_, idx) => (
            <div
              key={idx}
              className="article-link"
              style={{
                pointerEvents: "none",
                opacity: 0.5,
              }}
            >
              <div className="article-list-item">
                <div className="article-image" />
                <div className="article-meta">
                  <div className="article-text-loading"></div>
                  <div className="article-text-loading"></div>
                  <div className="article-text-loading"></div>
                  <div className="article-text-loading"></div>
                </div>
              </div>
            </div>
          ))}
    </ArticleListContainer>
  );
});
